import * as React from 'react';

function SvgArrowDown(props) {
  return (
    <svg viewBox="0 0 7 11" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 7l3.5 3L7 7M3.5 0v10"
        stroke="#38b2a6"
        fill="#38b2a6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgArrowDown;
